/* ==========================================================================
   Lombr — Global interactions
   ========================================================================== */

(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveal();
    initStickyHeader();
    initMobileMenu();
    initHorizontalTracks();
  });

  function initScrollReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    items.forEach(function (el) { observer.observe(el); });
  }

  function initStickyHeader() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;
    var threshold = 80;

    function update() {
      if (window.scrollY > threshold) header.classList.add('is-solid');
      else header.classList.remove('is-solid');
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var isOpen = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  function initHorizontalTracks() {
    var tracks = document.querySelectorAll('[data-horizontal-track]');
    if (!tracks.length) return;

    tracks.forEach(function (track) {
      var isDown = false;
      var startX, scrollLeft;

      track.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          track.scrollLeft += e.deltaY;
          e.preventDefault();
        }
      }, { passive: false });

      track.addEventListener('pointerdown', function (e) {
        isDown = true;
        track.classList.add('is-dragging');
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
      });
      ['pointerup', 'pointerleave'].forEach(function (evt) {
        track.addEventListener(evt, function () {
          isDown = false;
          track.classList.remove('is-dragging');
        });
      });
      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - track.offsetLeft;
        track.scrollLeft = scrollLeft - (x - startX) * 1.4;
      });
    });
  }
})();
